/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_Type_TaskInputs */

const cs_chat_attach_type_task = /** @type {(inputs: Chat_Attach_Type_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úkol`)
};

const en_chat_attach_type_task = /** @type {(inputs: Chat_Attach_Type_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

/**
* | output |
* | --- |
* | "Task" |
*
* @param {Chat_Attach_Type_TaskInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_type_task = /** @type {((inputs?: Chat_Attach_Type_TaskInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_Type_TaskInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_type_task(inputs)
	return cs_chat_attach_type_task(inputs)
});